import React from 'react';
import { BundlesSection } from '../BundlesSection';
import { SelectedServiceDetails } from '../BookingModal';
import { navigateTo } from '../../utils/router';

interface BundlesPageProps {
  selectedItems: SelectedServiceDetails[];
  onToggleService: (id: string, name: string, price: number) => void;
  selectedPackageId?: string | null;
}

export const BundlesPage: React.FC<BundlesPageProps> = ({
  selectedItems,
  onToggleService,
  selectedPackageId = null
}) => {
  return (
    <div className="multipage-view bundles-page-view">
      <h1 className="sr-only">
        {selectedPackageId
          ? `${selectedPackageId.replace('bundle-', '').replace(/-/g, ' ')} Package at Home in Bhilai & Durg | Blishka`
          : 'Curated Beauty Packages & Home Parlour Combos | Blishka Bhilai & Durg'}
      </h1>
      <div className="subpage-content-wrapper">
        <BundlesSection
          selectedServices={selectedItems.map((s) => s.id)}
          onToggleService={onToggleService}
          selectedPackageId={selectedPackageId}
          onSelectPackage={(pkgId) => {
            navigateTo('/bundles', { packageId: pkgId });
          }}
          onBackToBundles={() => {
            navigateTo('/bundles');
          }}
        />
      </div>
    </div>
  );
};
